import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  standalone: true,
  selector: 'sl-button',
  templateUrl: './sl-button.component.html',
  styleUrls: ['./sl-button.component.scss'],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SlButtonComponent {
  @ViewChild('nativeButton', { static: true }) nativeButtonRef!: ElementRef<HTMLButtonElement>;

  @Input() id!: string;
  @Input() ariaLabel?: string;
  @Input() iconName?: string;
  @Input() iconSvg?: string;
  @Input() formId?: string;
  @Input() label?: string;
  @Input() size?: 'small' | 'standard' = 'standard';
  @Input() shape?: 'rounded' | 'squared' = 'rounded';
  @Input() type?: 'label' | 'icon-left' | 'icon-right' | 'icon-only' = 'label';
  @Input() variant?: 'primary' | 'secondary' | 'tertiary' | 'header' = 'primary';
  @Input() theme?: 'light' | 'dark' = 'light';
  @Input() color?: 'basic' | 'danger' | 'input' = 'basic';
  @Input() textWeight?: 'button-light' | 'regular' | 'medium' | 'bold' | 'italic' = 'regular';
  @Input() disabled = false;
  @Input() fullWidth = false;
  @Input() submit? = false;
  @Output() clickEvent = new EventEmitter<Event>();
  @Output() keyDownEvent = new EventEmitter<KeyboardEvent>();

  handleClick(event: Event): void {
    this.clickEvent.emit(event);
  }

  handleKeyDown(event: KeyboardEvent): void {
    this.keyDownEvent.emit(event);
  }

  getClassObject() {
    return {
      [this.size ?? 'standard']: !!this.size,
      [this.type ?? 'label']: !!this.type,
      [this.variant ?? 'primary']: !!this.variant,
      [this.color ?? 'basic']: !!this.color,
      [this.theme ?? 'light']: !!this.theme,
      [this.shape ?? 'rounded']: !!this.shape,
      [this.textWeight ?? 'regular']: !!this.textWeight,
    };
  }

  getTextAlign(): string {
    return this.type === 'icon-left' ? 'row' : 'row-reverse';
  }

  getNativeElement(): HTMLButtonElement {
    return this.nativeButtonRef.nativeElement;
  }
}
